import { buildApiFromTlSchema } from './apiHelpers';

const Api = buildApiFromTlSchema();

export default Api;
